import { connectVpn, disconnectVpn } from './VpnCommands';
import { openDoor, closeDoor, maintenanceStart, maintenanceEnd, provision } from './CabinetCommands';

/**
 * DEVICE ACTIONS
 *
 * Device actions are commands sent to the Devices to perform various tasks. Commands themselves may connect to different backends etc.
 *
 * Device Commands
 */

/**
 * Link the command Strings to their respective handler functions
 *
 * This could be used later on to also filter the available commands to only those that already have that functionality available
 */
export const commandExecutors = {
    openVpn: connectVpn,
    closeVpn: disconnectVpn,
    openDoor,
    closeDoor,
    maintenanceModeOn: maintenanceStart,
    maintenanceModeOff: maintenanceEnd,
    provision,
    // cabinetReboot: cabinetReboot,
    // reboot:reboot,
    // hardReset: hardReset,
};

/**
 *
 * @param {*} device
 */
export function deviceTypeCommands(device) {
    if (process.env.REACT_APP_DEF_COMMANDS_CABINET_TYPES === undefined) {
        console.warn('Missing environment variable REACT_APP_DEF_COMMANDS_CABINET_TYPES! Cannot show commands.');
        return [];
    }
    const cabinetDevices = JSON.parse(process.env.REACT_APP_DEF_COMMANDS_CABINET_TYPES);

    if (device === undefined) {
        // console.warn("No device provided!");
        return [];
    }

    if (typeof device.type !== 'string') return [];

    const defaultCommands = cabinetDevices.includes(device.type.toLowerCase())
        ? JSON.parse(process.env.REACT_APP_DEF_COMMANDS_CABINET)
        : JSON.parse(process.env.REACT_APP_DEF_COMMANDS_OTHER);

    const supportedCommands =
        device.alternativeIds && device.alternativeIds.supportedCommands ? JSON.parse(device.alternativeIds.supportedCommands) : [];
    const unsupportedCommands =
        device.alternativeIds && device.alternativeIds.supportedCommands
            ? JSON.parse(device.alternativeIds.unsupportedCommands)
            : [];

    const commands = new Set(defaultCommands);

    supportedCommands.forEach(val => {
        commands.add(val);
    });

    unsupportedCommands.forEach(val => {
        commands.delete(val);
    });

    return Array.from(commands);
}

export function rebootDevice(device, params) {
    // return function(dispatch) {
    //     dispatch(showLoading());
    //     // connect to MQTT and send the command
    //     const client = io(process.env.REACT_APP_SOCKETIO_SERVER_URL);
    //     client.on('connect', () => {
    //         console.log(
    //             'Connected to ',
    //             process.env.REACT_APP_SOCKETIO_SERVER_URL
    //         );
    //         console.log(`device/${cabinet.id}/${getToken(cabinet)}/command`);
    //         client.emit(
    //             `device/${cabinet.id}/${getToken(cabinet)}/command`,
    //             'reboot'
    //         );
    //         client.close();
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify success
    //         // Notify(i18n.t('messages:Reboot command sent'));
    //     });
    //     client.on('error', () => {
    //         // hide loading bar
    //         dispatch(hideLoading());
    //         // notify failure
    //         console.log('reboot command sent error');
    //         // Notify(i18n.t('messages:Error', cabinet.id), 'error');
    //     });
    // };
}

export function updateMetaData(device) {
    // function(dispatch) {
    //     // make API call
    //     dispatch(showLoading());
    //     api_saveDeviceMetadata(device.code, newMetadata)
    //         .then(res => {
    //             dispatch(hideLoading());
    //             // notify user that new data was saved
    //             // Notify(i18n.t('messages:Success'));
    //         })
    //         .catch(err => {
    //             dispatch(hideLoading());
    //             // notify failure
    //             // Notify(i18n.t('messages:Error', device.code), 'error');
    //         });
    // };
}

export function updateDevice() {
    // function(dispatch) {
    //     // make API call
    //     dispatch(showLoading());
    //     api_updateDevice(device.code, data)
    //         .then(res => {
    //             dispatch(hideLoading());
    //             // update device data at the redux state
    //             dispatch({
    //                 type: 'DEVICE_UPDATED',
    //                 id: device.code,
    //                 data
    //             });
    //             // update side menu item
    //             dispatch({
    //                 type: 'UPDATE_SIDE_MENU_ITEM',
    //                 id: device.code,
    //                 oldName: device.name,
    //                 name: data.name
    //             });
    //         })
    //         .catch(err => {
    //             dispatch(hideLoading());
    //         });
    // };
}
